import { IconProps } from '@/lib';
import { FC } from 'react';

export const SelectAudienceStepIcon: FC<IconProps> = ({ className, pathClassName }) => (
  <svg className={className} width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      className={pathClassName}
      d='M15.5001 13.1974C16.7134 13.8069 17.7536 14.785 18.5128 16.008C18.6632 16.2502 18.7383 16.3713 18.7643 16.539C18.8172 16.8798 18.5841 17.2988 18.2667 17.4336C18.1105 17.5 17.9348 17.5 17.5834 17.5M13.8334 9.6102C15.0682 8.99657 15.9168 7.72238 15.9168 6.25C15.9168 4.77762 15.0682 3.50343 13.8334 2.8898M12.1668 6.25C12.1668 8.32107 10.4878 10 8.41678 10C6.34571 10 4.66678 8.32107 4.66678 6.25C4.66678 4.17893 6.34571 2.5 8.41678 2.5C10.4878 2.5 12.1668 4.17893 12.1668 6.25ZM2.6328 15.782C3.96139 13.7871 6.05792 12.5 8.41677 12.5C10.7756 12.5 12.8722 13.7871 14.2008 15.782C14.4918 16.219 14.6373 16.4375 14.6206 16.7166C14.6075 16.9339 14.4651 17.2 14.2914 17.3313C14.0684 17.5 13.7616 17.5 13.1481 17.5H3.68541C3.07192 17.5 2.76517 17.5 2.54214 17.3313C2.36848 17.2 2.22601 16.9339 2.21297 16.7166C2.19622 16.4375 2.34174 16.219 2.6328 15.782Z'
      stroke='currentColor'
      strokeWidth='1.66667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ConnectAudienceStepIcon: FC<IconProps> = ({ className, pathClassName }) => (
  <svg className={className} width='21' height='20' viewBox='0 0 21 20' fill='none'>
    <path
      className={pathClassName}
      d='M18.9333 9.23818V10.0049C18.9322 11.8019 18.3504 13.5504 17.2744 14.9897C16.1984 16.429 14.686 17.4819 12.9627 17.9914C11.2395 18.501 9.39765 18.4398 7.71199 17.817C6.02634 17.1942 4.58715 16.0433 3.60907 14.5357C2.63099 13.0282 2.16643 11.2449 2.28467 9.45178C2.4029 7.65866 3.09761 5.95179 4.26517 4.58575C5.43273 3.2197 7.01059 2.26767 8.76343 1.87164C10.5163 1.47561 12.3502 1.6568 13.9916 2.38818M18.9333 3.33341L10.5999 11.6751L8.09994 9.17508'
      stroke='#414651'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
